<template>
  <b-container id="main-container" fluid style>
    <b-row style="width: 100%; background-color: #e8e8ea" align-h="center">
      <b-col class cols="12">
        <nav-header></nav-header>
      </b-col>
    </b-row>

    <b-row style="width: 100%; margin-top: 60px" align-h="center">
      <b-col
        cols="12"
        style="max-width: 1200px; padding-top: 40px; padding-bottom: 100px"
        class="term_service"
      >
        <h1>Truthbrush Compliance</h1>
        <hr style="width: 100%; border: 0.5px solid gray" />
        <h2>Proper Disposal</h2>
        <p>
          Your Truthbrush Tracker or Hub, like any other equipment
          containing electronic components and/or batteries, cannot be disposed
          toegether with your regular household waste. It is your responsibility
          to dispose Truthbrush Tracker or Hub at an applicable
          collection point for proper recycling. The seperation of this
          collection and recycling will help to conserve natural resources and
          prevent potential negative consequences to the environment and to
          human health.
        </p>

        <p>
          For more information on where to drop of your battery equipmented
          Truthbrush tracker and hub for disposal, please contact your local
          city/municipality or your household waste disposal service. Conctact
          support@candibell.com for additional information regarding Proper
          Disposal.
        </p>

        <h2>FCC Compliance Statement</h2>

        <p>Operation is subject to the following two conditions:</p>
        <ul>
          <li>This device may not cause harmful interference, and</li>
          <li>
            This device must accept any interference received, including
            interference that may cause undesired operation.
          </li>
        </ul>
        <p>
          Note: This equipment has been tested and found to comply with the
          limits for a Class B digital device, pursuant to part 15 of the FCC
          Rules. These limits are designed to provide reasonable protection
          against harmful interference in a residential installation. This
          equipment generates uses and can radiate radio frequency energy and,
          if not installed and used in accordance with the instructions, may
          cause harmful interference to radio communications. However, there is
          no guarantee that interference will not occur in particular
          installation. If this equipment does cause harmful interference to
          radio or television reception, which can be determined by turning the
          equipment off and on, the user is encouraged to try to correct the
          interference by one or more of the following measures:
        </p>
        <ul>
          <li>Reorient or relocate the receiving antenna.</li>
          <li>Increase the separation between the equipment and receiver.</li>
          <li>
            Connect the equipment into an outlet on a circuit different from
            that to which the receiver is connected.
          </li>
          <li>
            Consult the dealer or an experienced radio/TV technician for help.
            Changes or modifications not expressly approved by the party
            responsible for compliance could void the user’s authority to
            operate the equipment.
          </li>
        </ul>

        <h4>FCC Radiation Exposure Statement</h4>

        <p>
          This device complies with FCC RF radiation exposure limits set forth
          for an uncontrolled environment. This transmitter must not be
          co-located or operating in conjunction with any other antenna or
          transmitter.
        </p>
        <p>FCC ID: 2AS6G-T1, 2AS6G-T2</p>
        <p>Contains FCC ID: 2AC7Z-ESPWROOM32D</p>
        <p></p>
        <p></p>

        <h2>Industry Canada</h2>
        <p>
          This device complies with RSS standards of the Industry Canada Rules.
          Operation is subject to the following two conditions:(1) This device
          may not cause harmful interference, and (2) this device must accept
          any interference received, including interference that may cause
          undesired operation.
        </p>
        <p>
          Ce dispositif est conforme à la norme CNR d’Industrie Canada
          applicable aux appareils radio exempts de licence. Son fonctionnement
          est sujet aux deux conditions suivantes: (1) le dispositif ne doit pas
          produire de brouillage préjudiciable, et (2) ce dispositif doit
          accepter tout brouillage reçu, y compris un brouillage susceptible de
          provoquer un fonctionnement indésirable.
        </p>
        <p>IC ID: 26421-T1</p>
        <p>Contains IC ID: 21098-ESPWROOM32D</p>

        <h2>Australia</h2>
        <p>Complies with AS/NZS 4268:2017 WiFi+BLE</p>
        <p></p>

        <h2>Water Resistant</h2>
        <p>Certified - IPX4 water resistant.</p>
      </b-col>
    </b-row>

    <b-row style="width: 100%">
      <nav-footer></nav-footer>
    </b-row>
  </b-container>
</template>

<script>
import NavHeader from "./../components/NavHeader";
import NavFooter from "./../components/NavFooter";
export default {
  name: "Home",
  components: {
    NavHeader,
    NavFooter,
  },
};
</script>

<style lang="scss">
.term_service h2 {
  padding-top: 15px;
}

@media (max-width: 768px) {
  .term_service h2,
  .term_service h4 {
    text-align: center;
  }
}
</style>